














import { Component, Vue } from 'vue-property-decorator';
import { Button } from '../../../components';

@Component({
  components: {
    Button,
  },
})
export default class MentoringSuccess extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/succss/MentoringSuccess.vue